import React from "react";
import PDCard from "../components/PDCard";
import { HITTERS_MOCK } from "../constants/hittersMock";
import { buildHitterCard } from "../utils/pdBuilders";

const getTopHitters = (data) => {
  // Create individualized hitter profiles with realistic variety
  const hitterProfiles = [
    {
      name: "Nick Fox",
      avg: 0.312,
      hardHitPct: 45.2,
      chasePct: 22.1,
      identityTag: "Elite contact with developing power",
      tierLabel: "",
      strengths: [
        "Hard contact, selective eye, gap power"
      ],
      improvements: [
        "Handle spin, add loft, repeat path"
      ],
      goalsShort: [
        "Keep chase percentage down, drive the ball with more impact"
      ],
      goalsLong: [
        "Contact skills carry, grow into 15+ HR power"
      ],
      developmentTiles: [
        { label: "Recognition Progress", value: "Breaking ball recognition showing improvement" },
        { label: "Cage Focus", value: "Launch angle work through swing adjustments" },
        { label: "Early Fix", value: "Swing path improved through mechanical work" }
      ]
    },
    {
      name: "Jake Allen",
      avg: 0.298,
      hardHitPct: 42.8,
      chasePct: 24.5,
      identityTag: "Balanced approach with gap power",
      tierLabel: "",
      strengths: [
        "Barrel control, patient ABs, run production"
      ],
      improvements: [
        "Handle spin, reduce chase, grind with 2 strikes"
      ],
      goalsShort: [
        "Keep chase rate down, drive more balls middle/oppo"
      ],
      goalsLong: [
        "Gap power plays, contact skills hold up at higher levels"
      ],
      developmentTiles: [
        { label: "Approach Progress", value: "Plate discipline refined through recognition work" },
        { label: "Cage Focus", value: "Two-strike approach through situational work" },
        { label: "Early Fix", value: "Opposite field contact through inside work" }
      ]
    },
    {
      name: "Tyler Armstrong",
      avg: 0.285,
      hardHitPct: 38.5,
      chasePct: 27.8,
      identityTag: "Contact-first with improving impact",
      tierLabel: "",
      strengths: [
        "Contact bat, line-drive stroke, competes w/ 2 strikes"
      ],
      improvements: [
        "Add impact, ID spin, elevate consistently"
      ],
      goalsShort: [
        "Time velocity better, trim chase vs breakers"
      ],
      goalsLong: [
        "10+ HR potential, utility role value"
      ],
      developmentTiles: [
        { label: "Contact Progress", value: "Ball-striking improving through strength work" },
        { label: "Cage Focus", value: "Pitch recognition through machine work" },
        { label: "Early Fix", value: "Timing improved through inside work" }
      ]
    }
  ];

  return hitterProfiles.map(buildHitterCard);
};

const HitterDevelopmentPlans = () => {
  const hitters = getTopHitters(HITTERS_MOCK);

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-blue-900 to-slate-900 text-white">
      {/* HEADER */}
      <div className="border-b border-white/10">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
          <h1 className="text-2xl font-bold tracking-tight text-white">⚡ Featured Hitter Dev Notes</h1>
          <div className="text-sm text-white/70">Development Notes</div>
        </div>
      </div>

      {/* BODY */}
      <main className="mx-auto max-w-7xl px-6 pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-8">
          {hitters.map((h, idx) => (
            <PDCard key={idx} player={h} />
          ))}
        </div>
      </main>
    </div>
  );
};

export default HitterDevelopmentPlans;
